import React from 'react';

const BuildStandards = () => {
  return (
    <section className="py-20 px-margin-mobile md:px-margin-desktop max-w-container-max mx-auto">
      <h2 className="font-headline-md text-headline-md text-center mb-16">Our <span className="text-gradient-gold">Build Standards</span></h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-gutter-desktop">
        <div className="glass-card p-8 rounded-lg group hover:border-primary/30 transition-all">
          <span className="material-symbols-outlined text-primary text-4xl mb-6">memory</span>
          <h3 className="font-headline-sm text-headline-sm mb-3">Efficient Code</h3>
          <p className="font-body-md text-on-surface-variant">Lightweight, high-speed execution to ensure no latency in trade execution or signal processing.</p>
        </div>
        <div className="glass-card p-8 rounded-lg group hover:border-primary/30 transition-all">
          <span className="material-symbols-outlined text-primary text-4xl mb-6">shield</span>
          <h3 className="font-headline-sm text-headline-sm mb-3">Zero Leaks</h3>
          <p className="font-body-md text-on-surface-variant">We ensure your strategy stays private with advanced security protocols and no "calling home".</p>
        </div>
        <div className="glass-card p-8 rounded-lg group hover:border-primary/30 transition-all">
          <span className="material-symbols-outlined text-primary text-4xl mb-6">tune</span>
          <h3 className="font-headline-sm text-headline-sm mb-3">Easy Config</h3>
          <p className="font-body-md text-on-surface-variant">Clean, labeled input parameters so you can optimize your strategy without touching any code.</p>
        </div>
        <div className="glass-card p-8 rounded-lg group hover:border-primary/30 transition-all">
          <span className="material-symbols-outlined text-primary text-4xl mb-6">history_edu</span>
          <h3 className="font-headline-sm text-headline-sm mb-3">Logs &amp; Debug</h3>
          <p className="font-body-md text-on-surface-variant">Built-in detailed logging to help you understand every trade action and decision in real-time.</p>
        </div>
      </div>
    </section>
  );
};

export default BuildStandards;
